import {
    isfCol,
    customsCol,
    deliveryOrderCol,
    exportDocumentCol,
    customsHoldCol,
    inputCol,
    releaseCol,
    emptyContainerCol,
    bookingConfirmationCol,
    stagesCol,
    proofCol,
    lfdCol,
    oceanFreightCol,
    airFreightCol,
    pierpassCol,
    importServiceFeeCol,
    cargoScheduleCol,
    schedulingCol,
    prealertCol,
    arrivalNoticeCol,
    appointmentCol,
    financeCol,
    closureCol,
    commentCol,
    disputeCol,
    aesitnCol,
} from 'features/todo/lib/TodoDef';

export const isfConfig = {
    header: ' 📑 ISF Filing',
    hasMulitiple: false,
    cols: isfCol,
    bgColor: '#fffcea',
};

export const customsConfig = {
    header: '🛃 Customs Clearance',
    hasMulitiple: false,
    cols: customsCol,
    bgColor: '#fffcea',
};

export const deliveryOrderConfig = {
    header: '📦 Delivery Order',
    hasMulitiple: false,
    cols: deliveryOrderCol,
    bgColor: '#fffcea',
};

export const exportDocumentConfig = {
    header: '📁 Export Documents',
    hasMulitiple: false,
    cols: exportDocumentCol,
    bgColor: '#fffcea',
};

export const aesItnConfig = {
    header: '📄 AES ITN Filing',
    hasMulitiple: false,
    cols: aesitnCol,
    bgColor: '#fffcea',
};

export const customsHoldConfig = {
    header: '⛔ Customs Hold',
    hasMulitiple: false,
    cols: customsHoldCol,
    bgColor: '#fffcea',
};
export const inputConfig = {
    header: '🖋️ Data Input',
    hasMulitiple: false,
    cols: inputCol,
    bgColor: '#d9f5ec',
};
export const releaseConfig = {
    header: '📜 BL Release',
    hasMulitiple: false,
    cols: releaseCol,
    bgColor: '#eaf7ff',
};
export const emptyContainerConfig = {
    header: '🕳️ Empty Container',
    hasMulitiple: false,
    cols: emptyContainerCol,
    bgColor: '#eaf7ff',
};
export const bookingConfirmationConfig = {
    header: '✅ Booking Confirmation',
    hasMulitiple: false,
    cols: bookingConfirmationCol,
    bgColor: '#eaf7ff',
};
export const stagesConfig = {
    header: '📶 Stages',
    hasMulitiple: false,
    cols: stagesCol,
    bgColor: '#eaf7ff',
};
export const proofConfig = {
    header: '📝 Proof of delivery',
    hasMulitiple: false,
    cols: proofCol,
    bgColor: '#eaf7ff',
};
export const lfdConfig = {
    header: '💰 Upcoming LFD',
    hasMulitiple: false,
    cols: lfdCol,
    bgColor: '#eaf7ff',
};

export const cargoScheduleConfig = {
    header: '🚀 Cargo Schedule',
    hasMulitiple: false,
    cols: cargoScheduleCol,
    bgColor: '#ffe5ec',
};
export const prealertConfig = {
    header: '🔔 Pre Alert',
    hasMulitiple: false,
    cols: prealertCol,
    bgColor: '#ffe5ec',
};
export const arrivalNoticeonfig = {
    header: '📢 Arrival Notice',
    hasMulitiple: false,
    cols: arrivalNoticeCol,
    bgColor: '#ffe5ec',
};
export const appointmentConfig = {
    header: "🚛 Today's Follow Up",
    hasMulitiple: false,
    cols: appointmentCol,
    bgColor: '#ffe5ec',
};
export const schedulingConfig = {
    header: '📅 Scheduling',
    hasMulitiple: false,
    cols: schedulingCol,
    bgColor: '#ffe5ec',
};
export const financeConfig = {
    header: '💼 Financial Documents',
    hasMulitiple: false,
    cols: financeCol,
    bgColor: '#ede4ff',
};
export const disputesConfig = {
    header: '❗ Disputes',
    hasMulitiple: false,
    cols: disputeCol,
    hasChip: true,
    bgColor: '#eaf7ff',
};
export const closureConfig = {
    header: '🔒 Shipment Closure',
    hasMulitiple: false,
    cols: closureCol,
    bgColor: '#e3eaf2',
};
export const commentConfig = {
    header: '🗨️ Comment',
    hasMulitiple: false,
    cols: commentCol,
    bgColor: '#e3eaf2',
};
export const airFreightConfig = {
    header: '✈️ Collect Charge',
    hasMulitiple: false,
    cols: airFreightCol,
};
export const oceanFreightConfig = {
    header: '🚢 Collect Charge',
    hasMulitiple: false,
    cols: oceanFreightCol,
};
export const pierPassConfig = {
    header: '🎫 Pierpass',
    hasMulitiple: false,
    cols: pierpassCol,
};
export const importServiceFeeConfig = {
    header: '🏗️ Import Service Fee',
    hasMulitiple: false,
    cols: importServiceFeeCol,
};

export const todoSections = (todoRows) => [
    { id: 1, value: 'documents', data: todoRows.todoSections.comment, config: commentConfig },
    { id: 2, value: 'trucking', data: todoRows.todoSections.appointment, config: appointmentConfig },
    { id: 3, value: 'trucking', data: todoRows.todoSections.lfd, config: lfdConfig },
    { id: 4, value: 'financial_documents', data: todoRows.todoSections.air_freight, config: airFreightConfig },

    {
        id: 5,
        value: 'financial_documents',
        data: todoRows.todoSections.import_service_fee,
        config: importServiceFeeConfig,
    },
    {
        id: 6,
        value: 'documents',
        data: todoRows.todoSections.booking_confirmation,
        config: bookingConfirmationConfig,
    },
    { id: 7, value: 'documents', data: todoRows.todoSections.stages, config: stagesConfig },
    {
        id: 8,
        value: 'customs_related',
        data: todoRows.todoSections.aes_itn_filing,
        config: aesItnConfig, // will change
    },
    {
        id: 9,
        value: 'documents',
        data: todoRows.todoSections.export_documents,
        config: exportDocumentConfig,
    },
    { id: 10, value: 'trucking', data: todoRows.todoSections.cargo_schedule, config: cargoScheduleConfig },
    { id: 11, value: 'trucking', data: todoRows.todoSections.scheduling, config: schedulingConfig },
    { id: 12, value: 'documents', data: todoRows.todoSections.prealert, config: prealertConfig },
    { id: 13, value: 'customs_related', data: todoRows.todoSections.isf_filing, config: isfConfig },
    { id: 14, value: 'documents', data: todoRows.todoSections.delivery_order, config: deliveryOrderConfig },
    { id: 15, value: 'documents', data: todoRows.todoSections.arrival_notice, config: arrivalNoticeonfig },
    { id: 16, value: 'customs_related', data: todoRows.todoSections.customs_hold, config: customsHoldConfig },
    { id: 17, value: 'customs_related', data: todoRows.todoSections.customs, config: customsConfig },
    { id: 18, value: 'financial_documents', data: todoRows.todoSections.ocean_freight, config: oceanFreightConfig },
    { id: 19, value: 'release', data: todoRows.todoSections.release, config: releaseConfig },
    { id: 20, value: 'trucking', data: todoRows.todoSections.pierpass, config: pierPassConfig },
    { id: 21, value: 'trucking', data: todoRows.todoSections.empty_container, config: emptyContainerConfig },
    { id: 22, value: 'trucking', data: todoRows.todoSections.proof, config: proofConfig },
    { id: 23, value: 'documents', data: todoRows.todoSections.data_input, config: inputConfig },
    { id: 24, value: 'financial_documents', data: todoRows.todoSections.finance, config: financeConfig },
    { id: 25, value: 'financial_documents', data: todoRows.todoSections.disputes, config: disputesConfig },
    { id: 26, value: 'trucking', data: todoRows.todoSections.closure, config: closureConfig },
];

export const categories = [
    { id: 1, title: 'Trucking', color: '#fffcea', value: 'trucking', size: 2.8 },
    { id: 2, title: 'Documents', color: '#d9f5ec', value: 'documents', size: 3.3 },
    { id: 3, title: 'Release', color: '#eaf7ff', value: 'release', size: 2.2 },
    { id: 4, title: 'Customs Related', color: '#ffe6d9', value: 'customs_related', size: 2.1 },
    { id: 5, title: 'Financial Documents', color: '#ede4ff', value: 'financial_documents', size: 1.6 },
];
